import gql from 'graphql-tag';

export const FILE_QUERY = gql`
  query FileQuery(
    $projectName: String!
    $entityName: String!
    $runName: String!
    $filename: String!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      name
      run(name: $runName) {
        id
        files(first: 1, names: [$filename]) {
          edges {
            node {
              id
              name
              directUrl
              md5
              sizeBytes
            }
          }
        }
      }
    }
  }
`;
